"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signupLoginOtp = void 0;
const constants_1 = require("../../constants/constants");
const axiosConfig_1 = require("../axios/axiosConfig");
const storageUtils_1 = require("../utils/storageUtils");
function signupLoginOtp(data, status, whitelabelDomain) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.WalletRoutes.signupLoginOtp(), data, (whitelabelDomain && {
                headers: {
                    whitelabelDomain: whitelabelDomain,
                },
            }) ||
                undefined);
            if (status === "signup" || response.data.token) {
                if (response.data.token) {
                    (0, storageUtils_1.setToken)(response.data.token);
                }
            }
            return response.data;
        }
        catch (err) {
            console.log("inenr otp err", err.response.data);
            return err.response.data;
        }
    });
}
exports.signupLoginOtp = signupLoginOtp;
